export const listingManager = {
  header: {
    title: "Oferty",
    newListingTitle: "Nowa oferta",
    reorderExit: "Zakończ zmianę kolejności",
    reorder: "Zmień kolejność ofert",
    done: "Gotowe",
    sort: "Sortuj",
    searchPlaceholder: "Szukaj…",
    searchClear: "Wyczyść",
    reorderHint: "Przeciągnij, aby zmienić kolejność",
  },
  globalBtn: {
    title: "Ustawienia globalne",
    sub: "Tożsamość i nowe rezerwacje · całe konto",
  },
  list: {
    of: "z",
    listingSingular: "oferta",
    listingPlural: "ofert",
    unitSingular: "jednostka",
    unitPlural: "jednostek",
    retry: "Ponów",
    noResults: 'Brak wyników dla "{query}"',
    viewUnits: "Zobacz jednostki",
    loadingUnits: "Wczytywanie jednostek…",
    refuerzaA: "Wspiera ofertę: {name}. Na razie przejmuje jej rezerwacje z kanałów",
    noUnits: "Brak jednostek",
    dragToMove: "Przeciągnij, aby przenieść",
    unitFallback: "Jednostka {n}",
  },
  empty: {
    title: "Wybierz ofertę",
    sub: "Wybierz ofertę z panelu po lewej, aby zarządzać jej ustawieniami.",
  },
  create: {
    title: "Nowa oferta",
    subtitle: "Utwórz ofertę, aby pogrupować swoje jednostki.",
    nameLabel: "Nazwa oferty",
    namePlaceholder: "Np. Loft w centrum",
    typeLabel: "Rodzaj obiektu",
    currencyLabel: "Waluta",
    currencyHint: "Waluty nie można zmienić po utworzeniu oferty.",
    submit: "Utwórz ofertę",
    nameRequired: "Nazwa jest wymagana.",
    errorCreate: "Nie udało się utworzyć oferty.",
    successCreate: "Oferta utworzona pomyślnie.",
  },
  delete: {
    titleListing: "Usuń ofertę",
    titleUnit: "Usuń jednostkę",
    text: "Zostanie usunięta z WACheckin. Tych zmian nie można cofnąć. Aby potwierdzić, wpisz nazwę:",
    placeholderListing: "Nazwa oferty",
    placeholderUnit: "Nazwa jednostki",
    deleting: "Usuwanie…",
    confirm: "Usuń",
    errorDelete: "Nie udało się usunąć.",
    successListing: "Oferta usunięta pomyślnie.",
    successUnit: "Jednostka usunięta pomyślnie.",
  },
  propertyTypes: {
    apartment: "Apartament",
    villa: "Willa",
    hotel: "Hotel",
    camping: "Kemping",
  },
  propertyTypeLabels: {
    apartment: "Apartament",
    house: "Dom",
    villa: "Willa",
    hotel: "Hotel",
    room: "Pokój",
    studio: "Kawalerka",
    fallback: "Obiekt",
  },
  toast: {
    errorLoad: "Błąd wczytywania ofert.",
    orderSaved: "Kolejność zapisana pomyślnie.",
    errorOrder: "Nie udało się zapisać kolejności.",
    nameUpdated: "Nazwa zaktualizowana.",
    errorName: "Nie udało się zaktualizować nazwy.",
  },
  common: {
    cancel: "Anuluj",
  },
  globalConfig: {
    hero: {
      title: "Ustawienia globalne",
      subPre: "Ustawienia agenta AI, które dotyczą",
      subStrong: "wszystkich Państwa obiektów",
      subPost: ".",
    },
    waba: {
      checking: "Sprawdzanie połączenia…",
      connected: "Połączono",
      start: "Zacznij tutaj",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Połącz WhatsApp Business",
      checkingSub: "Sprawdzanie statusu numeru…",
      numberPrefix: "Numer",
      verified: "zweryfikowany i gotowy do wysyłki ✓",
      pending: "oczekuje na weryfikację",
      linked: "Konto WhatsApp Business jest połączone.",
      linkPrompt: "Połącz swój numer, aby agent mógł odpowiadać Państwa gościom i pisać do nich na WhatsApp.",
      manage: "Zarządzaj",
      connect: "Połącz",
    },
    sectionLabel: "Ogólne · całe konto",
    badgeDefault: "AI ✨",
    requiresWaba: "Wymaga połączonego WhatsApp Business",
    notContracted: "Nie jest zawarte w Państwa planie. Prosimy o kontakt, aby to włączyć.",
    cards: {
      general: {
        title: "Ustawienia ogólne",
        sub: "Tożsamość i styl agenta",
      },
      newBookings: {
        title: "Nowe rezerwacje",
        sub: "Pierwszy kontakt, pytania i link do rezerwacji",
      },
      voiceAgent: {
        title: "Głosowy agent AI",
        sub: "Odbiera połączenia telefoniczne",
        badge: "NOWOŚĆ",
      },
    },
    foot: {
      pre: "Te ustawienia są",
      strong: "wspólne dla całego konta",
      post: ": zmiana tutaj stosuje je automatycznie do wszystkich ofert. Pozostała konfiguracja (check-in, dostęp, ceny…) pozostaje osobna dla każdej oferty.",
    },
  },
};
